var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["shipping/pdp-ship-accordion-header.j2"] = require( "shipping/pdp-ship-accordion-header.j2" );
dependencies["shipping/pdp-ship-restriction.j2"] = require( "shipping/pdp-ship-restriction.j2" );
dependencies["shipping/pdp-marketplace-shipping-returns.j2"] = require( "shipping/pdp-marketplace-shipping-returns.j2" );
dependencies["shipping/pdp-shipping-information.j2"] = require( "shipping/pdp-shipping-information.j2" );
dependencies["shipping/pdp-returns-information.j2"] = require( "shipping/pdp-returns-information.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-shipping-returns.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.sku.logisticClass"]));
frame.set("logisticClassCode", t_1, true);
if(frame.topLevel) {
context.setVariable("logisticClassCode", t_1);
}
if(frame.topLevel) {
context.addExport("logisticClassCode", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productDetails.shipRestriction.codeName"]));
frame.set("shipRestrictionCode", t_2, true);
if(frame.topLevel) {
context.setVariable("shipRestrictionCode", t_2);
}
if(frame.topLevel) {
context.addExport("shipRestrictionCode", t_2);
}
output += "\n";
var t_3;
t_3 = (lineno = 2, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "shipRestrictionCode"),runtime.makeKeywordArgs({"container": "shipRestrictionLocalization","orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("shipRestrictionString", t_3, true);
if(frame.topLevel) {
context.setVariable("shipRestrictionString", t_3);
}
if(frame.topLevel) {
context.addExport("shipRestrictionString", t_3);
}
output += "\n";
var t_4;
t_4 = (lineno = 3, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "logisticClassCode"),runtime.makeKeywordArgs({"container": "shipRestrictionLocalization","orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("logisticClassString", t_4, true);
if(frame.topLevel) {
context.setVariable("logisticClassString", t_4);
}
if(frame.topLevel) {
context.addExport("logisticClassString", t_4);
}
output += "\n";
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"sku") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productDetails")),"isFlatRate") && runtime.contextOrFrameLookup(context, frame, "shipRestrictionString") || runtime.contextOrFrameLookup(context, frame, "logisticClassString");
frame.set("hasRestrictions", t_5, true);
if(frame.topLevel) {
context.setVariable("hasRestrictions", t_5);
}
if(frame.topLevel) {
context.addExport("hasRestrictions", t_5);
}
output += "\n\n<div class=\"dom-shipping-returns-details\" data-qa-shipping-returns-details>\n    <div class=\"s-last-tab o-accordion__tabset js-accordion-tabset ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "isWebView")?"is-collapsed":""), env.opts.autoescape);
output += "\" data-accordion-tab-name=\"shipping\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <a\n                    href=\"#shipping-returns__panel\"\n                    id=\"shipping-returns__tab\"\n                    class=\"o-accordion__tab c-product-details__tab js-accordion-tab has-mouse-click-focus-disabled\"\n                    aria-selected=\"true\"\n                    aria-controls=\"shipping-returns__panel\"\n                    aria-expanded=\"false\"\n                    role=\"tab\"\n                    data-accordion-title=\"shipping returns\"\n                    >\n\n                    ";
env.getTemplate("shipping/pdp-ship-accordion-header.j2", false, "product/templates/product-shipping-returns.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
if(!runtime.contextOrFrameLookup(context, frame, "isWebView")) {
output += "<span class=\"o-accordion__control c-product-details__collapse\" title=\"collapse\"></span>";
;
}
output += "</a>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <div\n                    id=\"shipping-returns__panel\"\n                    class=\"o-accordion__panel js-accordion-panel c-product-details__section\"\n                    aria-labelledby=\"shipping-returns__tab\"\n                    aria-hidden=\"false\"\n                    role=\"tabpanel\"\n                    >";
if(runtime.contextOrFrameLookup(context, frame, "hasRestrictions")) {
env.getTemplate("shipping/pdp-ship-restriction.j2", false, "product/templates/product-shipping-returns.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
})});
}
output += "<div data-qa-shipping-details>";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isMarketPlace")) {
env.getTemplate("shipping/pdp-marketplace-shipping-returns.j2", false, "product/templates/product-shipping-returns.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
})});
}
else {
env.getTemplate("shipping/pdp-shipping-information.j2", false, "product/templates/product-shipping-returns.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n                            ";
env.getTemplate("shipping/pdp-returns-information.j2", false, "product/templates/product-shipping-returns.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
})})})});
}
output += "</div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-shipping-returns.j2"] , dependencies)